import list from 'src/modules/tipoActivo/list/tipoActivoListReducers';
import form from 'src/modules/tipoActivo/form/tipoActivoFormReducers';
import view from 'src/modules/tipoActivo/view/tipoActivoViewReducers';
import destroy from 'src/modules/tipoActivo/destroy/tipoActivoDestroyReducers';
import importerReducer from 'src/modules/tipoActivo/importer/tipoActivoImporterReducers';
import { combineReducers } from 'redux';

export default combineReducers({
  list,
  form,
  view,
  destroy,
  importer: importerReducer,
});
